import {
    schemeBuGn,
    schemeRdBu,
    schemeYlOrRd,
    schemeReds,
    schemeBlues,
    schemeGreens,
    schemeGreys,
} from 'd3-scale-chromatic';

export const FULL_SCHEME_RED = [
    ['#de2d26'],
    ['#ffffff', '#de2d26'],
    schemeReds[3],
    schemeReds[4],
    schemeReds[5],
    schemeReds[6],
    schemeReds[7],
    schemeReds[8],
    schemeReds[9],
];

export const FULL_SCHEME_GREEN = [
    ['#31a354'],
    ['#ffffff', '#31a354'],
    schemeGreens[3],
    schemeGreens[4],
    schemeGreens[5],
    schemeGreens[6],
    schemeGreens[7],
    schemeGreens[8],
    schemeGreens[9],
];

export const FULL_SCHEME_BLUE_GREEN = [
    ['#26565B'],
    ['#ffffff', '#26565B'],
    schemeBuGn[3],
    schemeBuGn[4],
    schemeBuGn[5],
    schemeBuGn[6],
    schemeBuGn[7],
    schemeBuGn[8],
    schemeBuGn[9],
];

export const FULL_SCHEME_BLUE = [
    ['#3182bd'],
    ['#ffffff', '#3182bd'],
    schemeBlues[3],
    schemeBlues[4],
    schemeBlues[5],
    schemeBlues[6],
    schemeBlues[7],
    schemeBlues[8],
    schemeBlues[9],
];

export const FULL_SCHEME_GREY = [
    ['#636363'],
    ['#ffffff', '#636363'],
    schemeGreys[3],
    schemeGreys[4],
    schemeGreys[5],
    schemeGreys[6],
    schemeGreys[7],
    schemeGreys[8],
    schemeGreys[9],
];

export const FULL_SCHEME_RD_BU = [
    ['#ef8a62'],
    ['#ef8a62', '#67a9cf'],
    schemeRdBu[3],
    schemeRdBu[4],
    schemeRdBu[5],
    schemeRdBu[6],
    schemeRdBu[7],
    schemeRdBu[8],
    schemeRdBu[9],
    schemeRdBu[10],
    schemeRdBu[11],
];

export const FULL_SCHEME_YL_OR_RD = [
    ['#bd0026'],
    ['#ffeda0', '#bd0026'],
    schemeYlOrRd[3],
    schemeYlOrRd[4],
    schemeYlOrRd[5],
    schemeYlOrRd[6],
    schemeYlOrRd[7],
    schemeYlOrRd[8],
    schemeYlOrRd[9],
];
